import { IAction } from "../model/IAction";

export const ADD_MANUALTRIGGER_KEY = "ADD_MANUALTRIGGER_KEY";
export function addManualTriggerKey(): IAction {
    return {
        type: ADD_MANUALTRIGGER_KEY,
    };
}

export const UPDATE_MANUALTRIGGER_KEY = "UPDATE_MANUALTRIGGER_KEY";
export function updateManualTriggerKey(index: number, newKey: string, validationError: string, isInvalid: boolean): UpdateManualTriggerAction {
    return {
        type: UPDATE_MANUALTRIGGER_KEY,
        index: index,
        newKey: newKey,
        validationError: validationError,
        isInvalid: isInvalid
    };
}

export const UPDATE_MANUALTRIGGER_TYPE = "UPDATE_MANUALTRIGGER_TYPE";
export function updateManualTriggerType(index: number, checked: boolean): UpdateDefaultManualTriggerType {
    return {
        type: UPDATE_MANUALTRIGGER_TYPE,
        index: index,
        checked: checked
    };
}

export const UPDATE_MANUALTRIGGER_DESCRIPTION = "UPDATE_MANUALTRIGGER_DESCRIPTION";
export function updateManualTriggerDescription(index: number, description: string): UpdateDefaultManualTriggerDescription {
    return {
        type: UPDATE_MANUALTRIGGER_DESCRIPTION,
        index: index,
        description: description
    };
}

export const REMOVE_MANUALTRIGGER_KEY = "REMOVE_MANUALTRIGGER_KEY";
export function removeManualTriggerKey(index: number): RemoveManualTriggerAction {
    return {
        type: REMOVE_MANUALTRIGGER_KEY,
        index: index
    };
}

export const USE_PROCESS_FOR_MONITORINGRULE_CHANGE = "USE_PROCESS_FOR_MONITORINGRULE_CHANGE";
export function useManualTriggerForMonitoringRuleChange(use: boolean): ProcessForMonitoringRuleChangeAction {
    return {
        type: USE_PROCESS_FOR_MONITORINGRULE_CHANGE,
        use: use
    };
}

export const REORDER_MANUALTRIGGER_PARAMS = "REORDER_MANUALTRIGGER_PARAMS";
export function reorderManualTriggerParams(oldIndex: number, newIndex: number): ReorderManualTriggerParamsAction {
    return {
        type: REORDER_MANUALTRIGGER_PARAMS,
        oldIndex: oldIndex,
        newIndex: newIndex
    };
}

export interface ProcessForMonitoringRuleChangeAction extends IAction {
    use: boolean;
}

export interface RemoveManualTriggerAction extends IAction {
    index: number;
}

export interface UpdateDefaultManualTriggerType extends IAction {
    index: number;
    checked: boolean;
}

export interface UpdateDefaultManualTriggerDefaultValue extends IAction {
    index: number;
    defaultValue: string;
}

export interface UpdateDefaultManualTriggerDescription extends IAction {
    index: number;
    description: string;
}

export interface UpdateManualTriggerAction extends IAction {
    newKey: string;
    index: number;
    validationError: string;
    isInvalid: boolean;
}

export interface ReorderManualTriggerParamsAction extends IAction {
    oldIndex: number;
    newIndex: number;
}
